import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Logo } from "./Logo";
import { images } from "../data/store";
export function AgeGate() {
  const [verified, setVerified] = useState(false);
  const [declined, setDeclined] = useState(false);
  return <AnimatePresence data-id="element-11" data-mp="3i8lhgbid0p67">
      {!verified && <motion.div className="fixed inset-0 z-[60] flex items-center justify-center bg-night px-6" role="dialog" aria-modal="true" aria-labelledby="age-gate-title" initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-12" data-mp="3i9wlmcfpvyxu">
          <img src={images.hero} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" data-id="element-13" data-mp="5236q9kys2mb" />
          <div className="absolute inset-0 bg-night/60" aria-hidden="true" data-id="element-14" data-mp="12hpke33z7gjh" />
          <div className="relative w-full max-w-md text-center" data-id="element-15" data-mp="xqh9t3qwtp4q">
            <Logo size="lg" showTagline data-id="element-16" data-mp="xp64gzhtg9bi" />
            {declined ? <div className="mt-12" data-id="element-17" data-mp="2xq2nrv85ldhs">
                <p id="age-gate-title" className="font-display text-2xl font-semibold" data-id="element-18" data-mp="2xr4c31e6jwhg">
                  Sorry, you need to be 18+
                </p>
                <p className="mt-3 text-sm text-muted" data-id="element-19" data-mp="2nzzwbzgok7lk">Our products are intended for adults only.</p>
                <button type="button" onClick={() => setDeclined(false)} className="mt-8 text-sm font-medium underline underline-offset-4 hover:text-brand" data-id="element-20" data-mp="2sxhx32kjngih">
                  Go back
                </button>
              </div> : <div className="mt-12" data-id="element-21" data-mp="251nmebhy2tox">
                <p id="age-gate-title" className="font-display text-2xl font-semibold" data-id="element-22" data-mp="252p1cr2300bx">
                  Are you 18 years or older?
                </p>
                <p className="mt-3 text-sm text-muted" data-id="element-23" data-mp="3a0pxufaa6l2">You must be of legal age to enter this store.</p>
                <div className="mt-8 grid grid-cols-2 gap-3" data-id="element-24" data-mp="86r94qmdxiap">
                  <button type="button" onClick={() => setVerified(true)} className="rounded-full bg-brand py-3.5 text-sm font-bold text-night transition-colors hover:bg-brand-dark" autoFocus data-id="element-25" data-mp="5t5n49twzwpp">
                    Yes, I'm 18+
                  </button>
                  <button type="button" onClick={() => setDeclined(true)} className="rounded-full border border-white/25 py-3.5 text-sm font-semibold transition-colors hover:border-white" data-id="element-26" data-mp="3o0v05vaooq8v">
                    No
                  </button>
                </div>
              </div>}
          </div>
        </motion.div>}
    </AnimatePresence>;
}